module.exports = __webpack_public_path__ + "img/poster-europop.c774ef12.jpg";